<script lang="ts">
  // <!-- We will create n number of data points not bigger than xRange -->

  const n = 500;
  const xRange = 40;
  const xDomain = [0, 35];
  const dist = { m: 8, sd: 2.5, color: 'red' };

  // <!-- This creates data points from a probability distribution curve of
  //  a normal distribution -->

  const normPDF = (m, sd, x) => {
    const numerator = Math.exp(-Math.pow(x - m, 2) / (2 * Math.pow(sd, 2)));
    const denominator = sd * Math.sqrt(2 * Math.PI);
    return numerator / denominator;
  };

  const createDatum = (i, dist) => {
    const x = xDomain[0] + (xRange * i) / n;
    const y = normPDF(dist.m, dist.sd, x);
    return {
      dist,
      index: i,
      x: x,
      y: y
    };
  };

  const data = new Array(n + 1).fill(0);

  $: data.forEach((datum, i) => {
    data[i] = createDatum(i, dist);
  });
</script>

<!-- Show a sample of data we just created -->
{#each data.slice(50, 60) as d}
  <div class="pb-1">{JSON.stringify(d, null, 2)}</div>
{/each}
